import { useQuery } from 'react-query'

import api from 'services/api'

export const useInsuranceCompanies = () =>
  useQuery(['insurance_companies'], () => api.insurance.getInsuranceCompanies())
